import { ModelInstance, BaseModel, ToBackHook, ToFrontHook } from './util';
import { WaterpoloStatistic } from './waterpolo-statistic';
import { GameTeamStatisticBase } from './game-team-statistic-base';

@ModelInstance({
  mappingFields: {
    team: 'team',
    competitor_team: 'competitorTeam'
  },
  relation: {
    team: WaterpoloStatistic,
    competitorTeam: WaterpoloStatistic
  }
})
export class WaterpoloGameTeamStatistic extends BaseModel implements GameTeamStatisticBase {
  team: WaterpoloStatistic;
  competitorTeam: WaterpoloStatistic;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
